import { useNuxtApp } from '#imports';
import { useCartStore } from '@/stores/cart';
import { sendGtmEvent } from '../gtmTracking';
import { useOrderStore } from '@/stores/order';
import { storeToRefs } from 'pinia';
import { setTrackingData } from '@/resources/tracking';
import { useConsentStore } from '@/stores/consent';

export const sendPageViewedEvent = async (to, error) => {
  const { $i18n, $mixpanel } = useNuxtApp();
  const cartStore = useCartStore();

  const orderStore = useOrderStore();
  const { orderId, orderConfirmation } = storeToRefs(orderStore);

  const cartId = await cartStore.getCartId();
  const confirmation = computed(() => orderConfirmation?.value);

  const consentStore = useConsentStore();
  const { Analytics, Marketing } = await consentStore.getUserCookiePreferences();

  $mixpanel.track('page_viewed', {
    eventProps: {
      orderId: Object.keys(orderId.value).length ? orderId.value : 'no order id',
      pageType: setTrackingData(to.name) ?? 'no data',
      pagePath: to.fullPath,
      pageUrl: window.location.href,
      cartId,
      pageTitle: document.title,
      errorMessage: error?.value?.statusMessage,
      transactionId: confirmation?.value ? confirmation?.value?.orderNumber : 'no transaction id'
    }
  });

  await consentStore.updateGTagConsent();

  sendGtmEvent({
    event: 'page_load',
    eventParams: {
      page: {
        info: {
          name: document?.title?.toLowerCase(),
          url: window.location.href,
          path: to?.path,
          referrer: document?.referrer || null,
          environment: import.meta.env.NODE_ENV === 'production' ? 'production' : 'staging'
        },
        category: {
          pageType: setTrackingData(to.name)
        },
        attributes: {
          // need to get country
          country: $i18n?.locale.value,
          language: $i18n?.locale.value,
          // pass user coookie preference as a variable to allow/ prevent tracking
          userConsent: Marketing ? 'granted' : 'denied'
        },
        _clear: true
      }
    }
  });
};
